import { AppCta } from '@/services/cms-api/home-page-content/types'
import { FunctionComponent, useState } from 'react'
import Image from 'next/image'
import { ArrowForwardIos, ArrowBackIos } from '@mui/icons-material'
import { useLanguage } from '@/context/LanguageContext'
import { useRouter } from 'next/navigation'
import { IMG_URL } from '@/utils/constants'

interface Prop {
  item: AppCta
  align?: 'left' | 'right'
  id: string
}
const AppCtaRenderer: FunctionComponent<Prop> = ({ item, align, id }) => {
  const { locale } = useLanguage()
  const router = useRouter()
  const [clicked, setClicked] = useState(false)
  const openUrl = (e: any, url: string): void => {
    // e.preventDefault()
    router.push(url)
  }
  return (
    <div id={id} className='flex items-center'>
      {align === 'right' && <hr className='border-t border-dashed border-secondaryMidStroke 2xl:w-48 xl:w-32 lg:w-10 hidden lg:flex' />}
      {
        clicked
          ? (
            <div className='p-6 bg-surfaceWebGrey border border-secondaryMidStroke rounded-2xl w-[289px] md:w-96 h-52 hover:border-hover flex justify-between gap-2'>
              <div className='flex flex-col justify-evenly text-medium text-xs font-medium md:text-sm md:w-1/2'>

                {
                    locale === 'mn'
                      ? (
                        <p className='text-textMid'>Та <span className='font-semibold text-textHigh'>iOS</span> болон <span className='font-semibold text-textHigh'>Android </span>
                          үйлдлийн системүүд дээр тухайн QR кодыг уншуулаад татаарай
                        </p>
                        )
                      : (
                        <p className='text-textMid'>Scan the QR code and download it on <span className='font-semibold text-textHigh'>iOS</span> and <span className='font-semibold text-textHigh'>Android </span>
                          operating systems
                        </p>
                        )
                  }
                <div className='flex mt-2 gap-2'>
                  <div className='w-10 h-10 bg-surfaceMid rounded-xl flex items-center justify-center cursor-pointer' onClick={(e) => openUrl(e, item.appstoreUrl)}>
                    <Image draggable={false} alt='img' src={IMG_URL + '/uploads/icons/ios.svg'} width={20} height={20} />
                  </div>
                  <div className='w-10 h-10 bg-surfaceMid rounded-xl flex items-center justify-center cursor-pointer' onClick={(e) => openUrl(e, item.playstoreUrl)}>
                    <Image draggable={false} alt='img' src={IMG_URL + '/uploads/icons/android.svg'} width={20} height={20} />
                  </div>
                </div>
              </div>
              <div className='w-40 hidden md:block'>
                <Image draggable={false} src={IMG_URL + item.qr} alt=' ' width={164} height={164} className='w-40 h-40 rounded-xl object-scale-down bg-surfaceInverse border border-secondaryMidStroke' />
              </div>
              <div className='h-full flex items-center cursor-pointer' onClick={() => setClicked(false)}>
                <ArrowBackIos className='text-medium text-sm text-textMid' />
              </div>
            </div>
            )
          : (
            <div onClick={() => setClicked(!clicked)} className='p-6 bg-surfaceWebGrey border border-secondaryMidStroke rounded-2xl w-[289px] md:w-96 h-52 hover:border-hover cursor-pointer flex items-center justify-between'>
              <div className='flex flex-col'>
                <Image draggable={false} src={IMG_URL + item.icon} alt=' ' width={56} height={56} className='p-1 w-14 h-14 rounded-xl object-scale-down bg-surfaceInverse border border-secondaryMidStroke' />
                <h1 className='mt-3 md:text-xl font-bold text-textHigh'>{locale === 'en' ? item.nameEn : item.nameMn}</h1>
                <div className='flex items-center mt-2'>
                  <p className='text-medium text-xs font-medium md:text-sm text-textMid'>{locale === 'en' ? item.descriptionEn : item.descriptionMn}</p>
                </div>
              </div>
              <ArrowForwardIos className='text-medium text-sm text-textMid' />
            </div>
            )
      }

      {align === 'left' && <hr className='border-t border-dashed border-secondaryMidStroke 2xl:w-48 xl:w-32 lg:w-10 hidden lg:flex' />}
    </div>
  )
}
export default AppCtaRenderer
